<template>
  <div class="result-container">
    <span v-if="index" style="font-weight: 600">Bài {{index}}</span>
    <span style="font-weight: 600">Đạo văn: {{ getLabelCheating(result.cheating.type) }}</span>
    <div v-if="+result.cheating.type !== 1 && dataMark && dataMark?.length > 0" class="result-item" v-for="item in dataMark" :key="item.id">
      <span style="font-weight: 700">Tiêu chí chính: {{ item.label }}</span>
      <div v-for="child in item.data" style="display: flex; flex-direction: column; gap: 5px; margin-left: 15px">
        <span style="font-weight: 600">-Tiêu chí phụ: {{ child.label }}</span>
        <span>Điểm: {{ child.score }}</span>
        <span>Nhận xét: <span v-html="child.comment_auto"></span></span>
      </div>
      <span style="margin-top: 10px; white-space: nowrap; font-weight: 500">
        Nhận xét chi tiết: <span style="word-break: break-word; font-weight: 400" v-html="item.comment_detail"></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultDetail',
  props: {
    result: {
      type: Object,
      required: true,
      default: {}
    },
    index: {
      type: Number,
      default: null
    }
  },
  computed: {
    dataMark() {
      if (this.result && this.result.teacher_marks.length > 0) {
        return this.result.teacher_marks.reduce((acc, item) => {
          const existingGroup = acc.find(group => group.key_parent === item.key_parent);
          if (existingGroup) {
            existingGroup.data.push(item);
          } else {
            acc.push({
              label: item.label_parent,
              key_parent: item.key_parent,
              comment_detail: item.comment_detail,
              data: [item]
            });
          }
          return acc;
        }, [])
      }
    }
  },
  methods: {
    getLabelCheating(value) {
      switch (value) {
        case 0:
          return 'Đạo văn 30% - 50%';
        case 1:
          return 'Đạo văn trên 50%';
        case 2:
          return 'Nghi ngờ'
        default:
          return 'Không có dấu hiệu đạo văn';
      }
    }
  }
}
</script>

<style scoped>
  .result-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    border-radius: 5px;
    border: 1px solid gray;
    padding: 10px 20px;
  }
  .result-item {
    border: 1px dashed gray;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    border-radius: 5px;
    padding: 10px;
  }
</style>